import React, { FC } from 'react';
import { getFotmattedDateCreated } from 'utils/date';
import styles from './BeneficiarItem.module.scss';
import { BeneficiariesTabBtn } from 'ui/BeneficiariesTabBtn';
import { addSpaceNumber } from 'utils/addSpaceNumber';

interface BeneficiarItemTypes {
  group: any;
  // group: ItemTypes; // add types
}

export const BeneficiarItem: FC<BeneficiarItemTypes> = ({ group }) => {
  const standart = group?.beneficiary?.virtual_accounts?.find(
    (acc: any) => acc.type === 'standard',
  );

  // console.log('group', group);
  return (
    <div className={styles.root}>
      <p
        className={styles.root_item__standart}
        style={{ display: 'flex', justifyContent: 'center' }}>
        {group.id}
      </p>
      <div
        className={styles.root_item}
        style={{ display: 'flex', justifyContent: 'center' }}>
        <BeneficiariesTabBtn
          title={group?.beneficiary?.is_active ? 'Активен' : 'Не активен'}
          isActive={group?.beneficiary?.is_active}
        />
      </div>
      <p
        className={styles.root_item__standart}
        style={{ display: 'flex', justifyContent: 'center' }}>
        {group.is_pro ? 'Да' : 'Нет'}
      </p>
      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <p className={styles.root_item__standart}>{group?.jur_name || group?.name}</p>
        <div style={{ display: 'flex', columnGap: '10px' }}>
          <p className={styles.root_item__for_ndfl}>{group.company}</p>
          {/* <p className={styles.root_item__for_ndfl}>{group.kpp}</p> */}
        </div>
      </div>
      {/* <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        {group?.beneficiary?.virtual_accounts?.map((elem: any) => (
          <p
            className={
              elem.type === 'standard'
                ? styles.root_item__standart
                : styles.root_item__for_ndfl
            }
            key={elem.tochka_uuid}>
            {elem.tochka_uuid}
          </p>
        ))}
      </div> */}

      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <p style={{ textAlign: 'end' }} className={styles.root_item__standart}>
          {addSpaceNumber(group.balance)}
        </p>
        <p style={{ textAlign: 'end' }} className={styles.root_item__for_ndfl}>
          {standart?.cash ? addSpaceNumber(standart?.cash) : null}
        </p>
      </div>
      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <p className={styles.root_item__standart} style={{ textAlign: 'end' }}>
          {group.commission_percent}%
        </p>
        <div style={{ display: 'flex', columnGap: '10px', justifyContent: 'end' }}>
          <p className={styles.root_item__for_ndfl} style={{ textAlign: 'end' }}>
            {addSpaceNumber(group.commission_min_amount)}
          </p>
          {/* <p className={styles.root_item__for_ndfl}>{group.kpp}</p> */}
        </div>
      </div>
      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <p className={styles.root_item__standart} style={{ textAlign: 'end' }}>
          {addSpaceNumber(group.hold)}
        </p>
        <div style={{ display: 'flex', columnGap: '10px', justifyContent: 'end' }}>
          <p className={styles.root_item__for_ndfl} style={{ textAlign: 'end' }}>
            {standart?.blocked_cash ? addSpaceNumber(standart?.blocked_cash) : null}
          </p>
          {/* <p className={styles.root_item__for_ndfl}>{group.kpp}</p> */}
        </div>
      </div>
      <p className={styles.root_item__standart}>
        {group?.beneficiary?.updated_at
          ? getFotmattedDateCreated(group?.beneficiary?.updated_at)
          : ''}
      </p>
    </div>
  );
};
